import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

export const RESERVE_PRODUCE_CANCEL_REQUEST = 'reserve_produce_cancel/REQUEST'
export const RESERVE_PRODUCE_CANCEL_SUCCESS = 'reserve_produce_cancel/SUCCESS'
export const RESERVE_PRODUCE_CANCEL_ERROR = 'reserve_produce_cancel/ERROR'
export const RESERVE_PRODUCE_CANCEL_CONFIRMATION_OPEN = 'reserve_produce_cancel/OPEN_CONFIRMATION'
export const RESERVE_PRODUCE_CANCEL_CONFIRMATION_CLOSE = 'reserve_produce_cancel/CLOSE_CONFIRMATION'

export function reserveProduceCancelRequest() {
    return {
        type: RESERVE_PRODUCE_CANCEL_REQUEST,
        payload: {},
    }
}

export function reserveProduceCancelSuccess(reserveType, data) {
    const industrialResourceBalance = data.industrial_resource_balance
    const reserves = data.reserves
    return {
        type: RESERVE_PRODUCE_CANCEL_SUCCESS,
        payload: { industrialResourceBalance, reserves, reserveType },
    }
}

export function reserveProduceCancelError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: RESERVE_PRODUCE_CANCEL_ERROR,
        payload: errorData,
    }
}

export function openCancelConfirmation() {
    return {
        type: RESERVE_PRODUCE_CANCEL_CONFIRMATION_OPEN,
        payload: {},
    }
}
export function closeCancelConfirmation() {
    return {
        type: RESERVE_PRODUCE_CANCEL_CONFIRMATION_CLOSE,
        payload: {},
    }
}

export default function reserveProduceCancel(buildingId) {
    return async (dispatch, getState) => {
        const { buildings, reserveProduceCancel, settings } = getState()
        if (reserveProduceCancel.submitting) {
            return
        }
        dispatch(reserveProduceCancelRequest())
        const building = buildings[buildingId]
        const reserveType = settings.buildings[building.type].reserve_type

        httpRequest(`/game_api/buildings/${buildingId}/reserves`, 'DELETE')
            .then(
                resp => dispatch(reserveProduceCancelSuccess(reserveType, resp)),
                errorData => dispatch(reserveProduceCancelError(errorData)),
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/reserve_produce_cancel.js